'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  OPENED_DROPDOWN: null,
  ATTEMPTED_UNINSTALL: null
});